import textCommon from './en/common.json'
import textDisplay from './en/display.json'
import textControlDisplay from './en/controlDisplaySchedule.json'
import textValidate from './en/validate.json'

export default {
   ...textCommon,
   "display": {
      ...textDisplay
   },
   "controlDosplaySchedule": {
      ...textControlDisplay
   },
   "validate":{
      ...textValidate
   }
}



// WEBPACK FOOTER //
// ./src/language/en.js